<template>
  <div ref="selectField">
    <div v-if="!isEditing">
      <read-only-field
        :label="$attrs.label"
        :value="$attrs.value"
        v-bind="$attrs"
        :formatter="formatter || defaultFormatter"
        @click="setEditMode($refs.selectField)"
        data-testid="selectFieldReadOnly"
      />
    </div>
    <div v-else>
      <AdsSelect
        v-bind="$attrs"
        v-on="$listeners"
        outlined
        data-testid="selectField"
      />
    </div>
  </div>
</template>

<script>
import { AdsSelect } from '@/components/app/AdsSelect.vue'
import toggleFieldMixin from './toggleFieldMixin'

export default {
  name: 'MultiSelectField',
  mixins: [toggleFieldMixin],
  components: {
    AdsSelect
  },
  props: {
    formatter: {
      type: Function,
      default: null
    }
  },
  methods: {
    defaultFormatter(values) {
      const items = this.$attrs.items
      let list = ''
      if (items && values) {
        values.forEach(val => {
          const item = items.find(o => val === o.value)
        list +=  (item ? item.text + ',' : '')
        });

      }
      return list;
    }
  }
}
</script>
